import { useCurrentUser } from 'src/hooks';
import type { OrgTabOptionsValue } from 'src/types';
import { Analytics, Settings, Users, Vendors } from '..';

type Props = {
  currentTab: OrgTabOptionsValue;
};

export const Body = ({ currentTab }: Props) => {
  const { user } = useCurrentUser();
  const isAdmin = user?.subscription.role === 'admin';

  return (
    <>
      {/* Tabs with content that extends the full width of the page */}
      {currentTab === 'users' && <Users />}
      {currentTab === 'analytics' && isAdmin && <Analytics />}

      {/* Other tabs have content that is contained within the page */}
      <div className='flex w-full flex-col items-center justify-center gap-8 bg-offWhite px-4 pb-8 pt-4 sm:gap-10 sm:px-8 sm:pb-12 sm:pt-6 md:gap-10 md:px-12 md:pb-16 md:pt-8 lg:gap-12'>
        {currentTab === 'vendors' && <Vendors />}
        {currentTab === 'settings' && <Settings />}
      </div>
    </>
  );
};
